<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import insertBeingBuilt from './images/IMG_5147.jpg';
</script>

<Section backgroundColor="blue" class="[&_p]:text-left">
	<h1>Expedited Production</h1>
	<p>
		Since Indow inserts are custom-made to your specific window dimensions, our
		production timelines can stretch to a month or more. (See current estimated
		lead times <a href="/estimated-lead-times">here</a>).
	</p>
	<p>
		We understand this can be a long time to wait for our customer to experience
		the comfort & quiet of Indow inserts. That's why we offer Expedited
		Production for an additional fee.
	</p>
	<p>
		Expedited Production allows you to "jump" your order ahead in our production
		queue and ensure your order is produced within 10 business days of your
		final invoice being paid in full.
	</p>
	<Image src={insertBeingBuilt} class="no-bleed" />
</Section>

<Section class="[&_p]:text-left">
	<h2>Pricing</h2>
	<p class="w-full">
		Expedited Production fees are added based on the number of panels on the
		order:
	</p>
	<ul>
		<li><p>4 panels or less = $100</p></li>
		<li><p>5-9 panels = $200</p></li>
		<li><p>10-14 panels = $300</p></li>
		<li><p>15-19 panels = $400</p></li>
		<li><p>20-25 panels = $500</p></li>
	</ul>
</Section>

<Section backgroundColor="white" class="[&_p]:w-full [&_p]:text-left">
	<h2
		class="
    w-full text-left
    md:text-center
  "
	>
		Restrictions
	</h2>
	<p>
		Not all orders are eligible for Expedited Production. The following
		exclusions apply:
	</p>
	<ul>
		<li><p>Orders with any Specialty Shape panel</p></li>
		<li><p>Orders with custom bow cuts</p></li>
		<li><p>Orders with 26 or more panels</p></li>
	</ul>
	<p>
		In order to begin production on any order, Indow must receive full payment
		of any outstanding invoice related to the order, including the Expedited
		Production fee. If you are in possession of one of our Laser Measure Kits,
		Indow must receive confirmation that the Kit has been sent back through USPS
		or a previously approved alternate shipper in order to ship your order.
	</p>
	<p>
		Once these conditions have been met, your order will be produced, packaged,
		and shipped within 10 business days (excluding holidays). If Indow can not
		meet this timeline, the Expedited Production fee will be eligible for a full
		refund.
	</p>
	<p>
		Please note that Expedited Production does not guarantee any specific dates
		or timelines for delivery of your order. Any changes to your order may alter
		the timeline for Expedited Production.
	</p>
	<p>
		Indow reserves the right to suspend Expedited Production or adjust related
		fees at any time, for reasons including, but not limited to inclement
		weather, supply shortages, and other unforeseen circumstances.
	</p>
</Section>
